// extracted by mini-css-extract-plugin
export default {"td_leads":"payout_td_leads__myxWB","tr_leads":"payout_tr_leads__m+WOZ","reconfirm_icons1":"payout_reconfirm_icons1__zKd10","internal_qc_icons":"payout_internal_qc_icons__KOnkw"};